import React from "react";

// Estado vacío con ícono Font Awesome, título y descripción.
const EmptyState = ({ icon = "fa-inbox", title, children }) => (
  <div className="esen-empty">
    <span className="esen-empty-icon">
      <i className={`fa ${icon}`} aria-hidden="true"></i>
    </span>
    <h3>{title}</h3>
    {children ? <p>{children}</p> : null}
  </div>
);

export default EmptyState;
